import { createStore } from 'vuex'

export default createStore({
  state: {
    isNavOpen: false,
    selectedLanguage: 'En'
  },
  getters: {
    getIsNavOpen(state) {
      return state.isNavOpen;
    },
    getSelectedLanguage(state) {
      return state.selectedLanguage;
    }
  },
  mutations: {
    openMenuMutation(state, payload) {
      state.isNavOpen = !state.isNavOpen;
    },
    selectedLanguageMutation(state, payload) {
      state.selectedLanguage = payload;
    }
  },
  actions: {
    openMenuAction(context, payload) {
      context.commit('openMenuMutation', payload)
    },
    selectedLanguageAction(context, payload) {
      context.commit('selectedLanguageMutation', payload)
    }
  }
})